import { useEffect } from "react";
import queryString from "query-string";
import { useSaveConstantContactAuthDataMutation } from "../../../../../api/constantContact/useSaveConstantContactAuthDataMutation";
import { uiNotification } from "../../../../../services/UINotificationService";
import {
  INTEGRATION_SYNC_ALL_KEY,
  INTEGRATION_SYNC_NEW_KEY,
  TOKEN_QUERY_PARAM,
} from "../config";

export function useAuthenticateIntegration({ onSuccess }) {
  const { mutateAsync } = useSaveConstantContactAuthDataMutation({
    onSuccess,
    onError: () => {
      uiNotification.error("Unable to save integration data. Try again later.");
    },
  });

  const getCode = () => {
    const searchParams = queryString.parse(window.location.search);
    return searchParams?.[TOKEN_QUERY_PARAM] || null;
  };

  useEffect(() => {
    const code = getCode();

    if (code) {
      mutateAsync({
        accessToken: code,
        syncAll: localStorage.getItem(INTEGRATION_SYNC_ALL_KEY) === "true",
        syncNew: localStorage.getItem(INTEGRATION_SYNC_NEW_KEY) === "true",
      });
    } else {
      uiNotification.error("Authorization code is missing.");
    }
  }, []);
}
